<template>
  <div class="fs-color-picker">
    <v-popover :open="isOpened">
      <a class="fs-color-picker-preview mi tooltip-target" @click="toogleColorPicker()">
        {{icon ?  icon : 'text_format'}}
        <span class="fs-color-hide"></span>
        <span class="fs-color" :style="{ backgroundColor: value }"></span>
      </a>
      <template slot="popover"
        ><chrome-picker class="fs-color-picker-input" :value="value || ''" @input="onColorUpdate" />
      </template>
    </v-popover>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Model, Prop } from 'vue-property-decorator';
import { Chrome } from 'vue-color';

@Component({
  components: {
    'chrome-picker': Chrome,
  },
})
class ColorPicker extends Vue {
  @Prop() public isBorder: boolean;

  @Prop() public icon: string;

  @Model('input')
  private value: string;

  private isOpened: boolean = false;

  private onColorUpdate(col: any) {
    const rgb = col.rgba;
    this.$emit('input', `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})`);
  }

  private toogleColorPicker() {
    this.isOpened = !this.isOpened;
  }
}

export default ColorPicker;
</script>
